export default class rolePicker {

  constructor() {
    const rolePickers = document.querySelectorAll('select#role_drop');
    if (rolePickers.length) {
      this.rolePickers = rolePickers;
      this.initRolePicker();
    }
  }

  initRolePicker() {
    const roleTable = document.querySelector('.role-table');

    if (roleTable) {
      this.rolePickers.forEach(function(picker) {
        picker.onchange = (e) => {
          const appUsername = roleTable.getAttribute('data-name');
          const username = picker.getAttribute('data-update-url').split('members/').pop().split('/update-role')[0],
          data = {};
          data['role'] = e.target.value;

          $.ajax({
            url : picker.getAttribute('data-update-url'),
            type: 'POST',
            data : data,
            success: function(res) {
              if (username === appUsername && res.role === 'user') {
                disableAllRolePickers(rolePickers);
              }
            }
          });
        }
      });
    }

    if (roleTable && roleTable.getAttribute('data-update') == 'false' ) {
      this.disableAllRolePickers(this.rolePickers);
    }
  }

  disableAllRolePickers(elements) {
    elements.forEach(function(elem) {
      elem.disabled = true;
    })
  }
}
